var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9941 0H0.00585938C0.00262333 0 0 0.00262333 0 0.00585938V19.9941C0 19.9974 0.00262333 20 0.00585938 20H19.9941C19.9974 20 20 19.9974 20 19.9941V0.00585938C20 0.00262333 19.9974 0 19.9941 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88281 6.75781C4.88281 6.60156 4.80469 6.40625 4.6875 6.32812L3.47656 4.84375V4.60938H7.30469L10.2344 11.0938L12.8516 4.60938H16.4844V4.84375L15.4297 5.85938C15.3516 5.89844 15.3125 6.01562 15.3125 6.13281V13.5547C15.3125 13.6719 15.3516 13.7891 15.4297 13.8672L16.4844 14.8438V15.0781H11.2891V14.8438L12.3438 13.8281C12.4609 13.7109 12.4609 13.6719 12.4609 13.5156V7.53906L9.49219 15.0391H9.10156L5.66406 7.53906V12.5781C5.625 12.7734 5.70312 13.0078 5.85938 13.1641L7.22656 14.8438V15.0391H3.32031V14.8438L4.6875 13.1641C4.84375 13.0078 4.92188 12.7734 4.88281 12.5781V6.75781Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium.a1ae9ef4.svg";
export { ForwardRef as ReactComponent };